import * as yup from 'yup';
import { NAME_REGEX, isValidPostcode, phoneRegExp } from '@/modules/common/utils/regex.ts';
import { EntityPreferredContactWay } from 'api';

export const contactDetailsValidationSchema = yup.object({
  entity_name: yup
    .string()
    .trim()
    .matches(NAME_REGEX, 'Invalid format, only allowed: letters, apostrophes, spaces, hyphens')
    .nullable(),
  contact_name: yup
    .string()
    .trim()
    .matches(NAME_REGEX, 'Invalid format, only allowed: letters, apostrophes, spaces, hyphens')
    .nullable(),
  address: yup.string().trim().max(80).required('This field is required'),
  additional_address: yup.string().trim().max(80).nullable(),
  phone_number: yup
    .string()
    .trim()
    .when('country', ([country], schema) =>
      country === 'CHN'
        ? schema.matches(/^\d{11}$/, 'Phone number must contain 11 digits, e.g. 13800138000')
        : schema.matches(
            phoneRegExp,
            'Invalid phone number format, e.g. +61 412 345 678 or 11234567890',
          ),
    )
    .required('This field is required'),
  email: yup.string().trim().email('Must be a valid email').required('This field is required'),
  additional_emails: yup
    .array()
    .of(yup.string().trim().required('This field is required').email('Must be a valid email'))
    .nullable(),
  notifications_enabled: yup.boolean(),
  send_information_about_other_investments: yup.boolean(),
  preferred_contact_way: yup
    .mixed<EntityPreferredContactWay>()
    .oneOf(Object.values(EntityPreferredContactWay))
    .required('This select is required'),
  suburb: yup.string().trim().required('This field is required'),
  state: yup
    .string()
    .trim()
    .when('country', ([country], schema) => {
      if (country === 'AUS' || country === 'USA') {
        return schema.required('This field is required');
      }

      return schema.nullable();
    }),
  postcode: yup
    .string()
    .trim()
    .test('postcode-format', 'Invalid postcode format', function validatePostcode(value) {
      return !value || isValidPostcode(this.parent.country, value);
    })
    .required('This field is required'),
  country: yup.string().trim().required('This field is required'),
});
